import { useButtonHandlers } from '../../../../elements/controls/index.js'
import Icon from '../../../../elements/images/Icon/index.js'
import Button from '../PlayerControls/Button.js'

export const NextEpisodeControl = ({ nextEpisode, iconSize }) => {
  const { handlers } = useButtonHandlers()

  return (
    <Button onPress={() => handlers.playFeature(nextEpisode, 'replace')}>
      <Icon name="skip-next" size={iconSize} />
    </Button>
  )
}
